// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"FormSubTitle_subTitle_3qCEF"};
    if(module.hot) {
      // 1789136763072
      var cssReload = require("/drone/src/node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  